// Core plugin utilities
export * from './plugin-manager.js';

// CLI utilities
export * from './cli/index.js';

// Export local types
export type { Logger, Plugin, PluginContext } from './types.js';

// Augment the @api-buddy/types module with our local types
declare module '@api-buddy/types' {
  export * from './types.js';
}

// Default export for backward compatibility
import { SimplePluginManager } from './plugin-manager.js';
import * as cli from './cli/index.js';

const defaultExport = {
  SimplePluginManager,
  ...(cli.default || {})
};

export default defaultExport;
